import {
  Col,
  DatePicker,
  Divider,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import { ServiceAPIs } from "../../services/ChallengeAPIs";
import moment from "moment";

const AddForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [emojis, setEmojis] = useState([]);
  const [formData, setFormData] = useState(data);
  const [seasonal, setSeasonal] = useState(false);
  const [oneTime, setOneTime] = useState(false);
  const { addChallenge, getEmojis } = ServiceAPIs();

  const onCreate = (values) => {
    console.log(formData, "datappp");
    addChallenge(setLoading, values, hide, refresh, formData);
  };

  useEffect(() => {
    getEmojis(setEmojis);
    if (!data) return;
    setFormData(data);
    const formattedTitle = data?.title?.startsWith("I do") ? data?.title?.replace(/^I do\s*/, "") : data?.title;
    form.setFieldsValue({
      ...data,
      title: formattedTitle,
      start_date: data.start_date ? moment(data?.start_date) : null,
      end_date: data.end_date ? moment(data?.end_date) : null
    });
    setOneTime(data?.is_onetime ? true : false)
    setSeasonal(data?.category === "seasonal");
  }, [data]);

  const handleIsOneTime = (key) => {
    if (key === "seasonal") {
      form.setFieldValue("is_onetime", true);
    } else {
      form.setFieldValue("is_onetime", null);
    }
  }

  return (
    <Modal
      open={show}
      width={750}
      okText={data ? "Update" : "Add"}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
    >
      <Form
        id="create"
        form={form}
        onFinish={onCreate}
        layout="vertical"
        initialValues={{}}
      >
        <div className="add_user_title">
          <h4 className="modal_title_cls">{`${data ? "Edit Challenge" : "Add Challenge"
            }`}</h4>
        </div>
        <Row gutter={[16, 0]}>
          <Col span={12} sm={12}>
            <Form.Item
              label={`Challenge Category`}
              name="category"
              rules={[{ required: true, message: "Please select category" }]}
            >
              <Select
                className=""
                onChange={(key) => {
                  form.setFieldValue("category", key);
                  setSeasonal(key === "seasonal");
                  handleIsOneTime(key)
                } }
                autoComplete="off"
                placeholder="Select Challenge Category"
              >
                <Select.Option key={0} value={"mind"}>
                  Mind
                </Select.Option>
                <Select.Option key={1} value={"body"}>
                  Body
                </Select.Option>
                <Select.Option key={2} value={"spirit"}>
                  Spirit
                </Select.Option>
                <Select.Option key={3} value={"seasonal"}>
                  Seasonal
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={12} sm={12}>
            <Form.Item
              label={`Challenge Name`}
              name="title"
              className="main-new-clallange-name-class-ido"
              rules={[
                { required: true, message: "Please enter name" },
                {
                  max: 500,
                  message: "Name should not contain more then 500 characters!",
                },
                {
                  min: 2,
                  message: "Name should contain at least 2 characters!",
                },
              ]}
              normalize={(value) => value?.trimStart()}
            >
              <Input
                addonBefore="I do"
                autoComplete="off"
                placeholder={`Enter Challenge Name`}
              />
            </Form.Item>
          </Col>

          <Col span={(seasonal || oneTime) ? 12 : 8} sm={(seasonal || oneTime) ? 12 : 8}>
            <Form.Item
              label={`Emoji`}
              name="emoji"
              rules={[{ required: true, message: "Please enter emoji" }]}
            >
              <Select
                className=""
                onChange={(key) => form.setFieldValue("emoji", key)}
                autoComplete="off"
                placeholder="Select Emoji"
                showSearch
                filterOption={(input, option) =>
                  option.children?.[2]
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {emojis.map((emoji) => (
                  <Select.Option
                    className="cap"
                    key={emoji.unified}
                    value={String.fromCodePoint(parseInt(emoji.unified, 16))}
                  >
                    <span>
                      {String.fromCodePoint(parseInt(emoji.unified, 16))}{" "}
                    </span>{" "}
                    {emoji.name[0] + emoji.name.substring(1)?.toLowerCase()}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={(seasonal || oneTime) ? 12 : 8} sm={(seasonal || oneTime) ? 12 : 8}>
            <Form.Item
              label={`Is One Time?`}
              name="is_onetime"
              rules={[{ required: true, message: "Please select is onetime!" }]}
            >
              <Select
                className=""
                onChange={(key) => {
                  setOneTime(key);
                  form.setFieldValue("is_onetime", key);
                }}
                autoComplete="off"
                placeholder="One Time"
                disabled={seasonal}
              >
                <Select.Option key={0} value={true}>
                  Yes
                </Select.Option>
                <Select.Option key={1} value={false}>
                  No
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>

          {oneTime || seasonal ? (
            <>
              <Col span={24} sm={24} md={12}>
                <Form.Item
                  className="username "
                  name="start_date"
                  label="Start Date"
                  rules={[
                    {
                      required: true,
                      message: "Please select start date!",
                    },
                  ]}
                >
                  <DatePicker
                    disabled={data?.is_uploaded ? true : false}
                    className="date-inn"
                    placeholder={"Enter Start Date"}
                    format="DD-MM-yyyy"
                    disabledDate={(current) => {
                      return current && current < moment().startOf("day");
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={24} sm={24} md={12}>
                <Form.Item
                  className="username "
                  name="end_date"
                  label="End Date"
                  rules={[
                    {
                      required: true,
                      message: "Please select end date!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const startDate = getFieldValue("start_date");

                        if (!startDate || !value) {
                          return Promise.resolve();
                        }

                        if (moment(value).isBefore(moment(startDate), "day")) {
                          return Promise.reject(new Error("End Date cannot be before Start Date!"));
                        }

                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <DatePicker
                    disabled={data?.is_uploaded ? true : false}
                    // disabled={data?.is_uploaded || !form.getFieldValue("start_date")} 
                    className="date-inn"
                    placeholder={"Enter End Date"}
                    format="DD-MM-yyyy"
                    // disabledDate={(current) => {
                    //   return current && current < moment().startOf("day");
                    // }}
                    disabledDate={(current) => {
                      const startDate = form.getFieldValue("start_date");
                      return startDate ? current < moment(startDate).startOf("day") : true;
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          ) : (
            <Col span={8} sm={8}>
              <Form.Item
                label={`Challenge Duration`}
                name="duration"
                rules={[{ required: true, message: "Please select duration" }]}
              >
                <Select
                  className=""
                  onChange={(key) => form.setFieldValue("duration", key)}
                  autoComplete="off"
                  placeholder="Select Challenge Duration"
                >
                  <Select.Option key={0} value={30}>
                    30 Days
                  </Select.Option>
                  <Select.Option key={1} value={60}>
                    60 Days
                  </Select.Option>
                  <Select.Option key={2} value={90}>
                    90 Days
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
          )}

          <Col span={24} sm={24}>
            <Form.Item
              label={`Challenge Description`}
              name="description"
              rules={[
                { required: true, message: "Please enter description" },
                {
                  max: 500,
                  message:
                    "Description should not contain more then 500 characters!",
                },
                {
                  min: 10,
                  message: "Description should contain at least 10 characters!",
                },
              ]}
              normalize={(value) => value?.trimStart()}
            >
              <Input.TextArea
                autoComplete="off"
                placeholder={`Enter Description`}
              />
            </Form.Item>
          </Col>

          <Divider />

          <Col span={12} sm={24}>
            <Form.Item
              label={`Challenge Rules`}
              name="rules"
              // rules={[
              //   { required: true, message: "Please enter rules" },
              //   {
              //     max: 500,
              //     message: "Rules should not contain more then 500 characters!",
              //   },
              //   {
              //     min: 10,
              //     message: "Rules should contain at least 10 characters!",
              //   },
              // ]}
              normalize={(value) => value?.trimStart()}
            >
              <Input.TextArea
                autoComplete="off"
                placeholder={`Enter Challenge Rules`}
              />
            </Form.Item>
          </Col>

          <Col span={12} sm={12}>
            <Form.Item
              label={`Challenge Objective`}
              name="objective"
              // rules={[
              //   { required: true, message: "Please enter objective" },
              //   {
              //     max: 500,
              //     message: "Objective should not contain more then 500 characters!",
              //   },
              //   {
              //     min: 10,
              //     message: "Objective should contain at least 10 characters!",
              //   },
              // ]}
              normalize={(value) => value?.trimStart()}
            >
              <Input.TextArea
                autoComplete="off"
                placeholder={`Enter Challenge Objective`}
              />
            </Form.Item>
          </Col>

          <Col span={12} sm={12}>
            <Form.Item
              label={`Tasks & Points`}
              name="task_points"
              // rules={[
              //   { required: true, message: "Please enter tasks & points" },
              //   {
              //     max: 1000,
              //     message: "Tasks & Points should not contain more then 1000 characters!",
              //   },
              //   {
              //     min: 10,
              //     message: "Tasks & Points should contain at least 10 characters!",
              //   },
              // ]}
              normalize={(value) => value?.trimStart()}
            >
              <Input.TextArea
                autoComplete="off"
                placeholder={`Enter Tasks & Points`}
              />
            </Form.Item>
          </Col>

          <Col span={12} sm={12}>
            <Form.Item
              label={`Complexity Level`}
              name="complexity"
            // rules={[
            //   { required: true, message: "Please select complexity level" },
            // ]}
            >
              <Select
                className=""
                onChange={(key) => form.setFieldValue("complexity", key)}
                autoComplete="off"
                placeholder="Select Challenge Category"
              >
                <Select.Option key={0} value={"easy"}>
                  Easy
                </Select.Option>
                <Select.Option key={1} value={"Medium"}>
                  Medium
                </Select.Option>
                <Select.Option key={2} value={"hard"}>
                  Hard
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={12} sm={12}>
            <Form.Item
              label={`Candidate Nature`}
              name="candidate"
            // rules={[
            //   { required: true, message: "Please select candidate nature" },
            // ]}
            >
              <Select
                className=""
                onChange={(key) => form.setFieldValue("candidate", key)}
                autoComplete="off"
                placeholder="Select Candidate"
              >
                <Select.Option key={0} value={"solo"}>
                  Solo
                </Select.Option>
                <Select.Option key={1} value={"group"}>
                  Group
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddForm;
